import { render, staticRenderFns } from "./TapeView.vue?vue&type=template&id=a58f7fc8"
import script from "./TapeView.vue?vue&type=script&lang=js"
export * from "./TapeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports